// extracted by mini-css-extract-plugin
module.exports = {"queue-header":"styles_queue-header__HUz4S"};